import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { AuthShell, field, label, primaryBtn } from "@/pages/Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata, accedi di nuovo");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Link non valido o scaduto");
    } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Nuova password" subtitle="Scegli una nuova password sicura">
      <form onSubmit={submit} className="space-y-4">
        <div><label className={label}>Nuova password</label><input className={field} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password-input" /></div>
        <button className={primaryBtn} disabled={loading || !token} data-testid="reset-submit-button">{loading ? "Aggiornamento..." : "Aggiorna password"}</button>
        <Link to="/login" className="block text-center text-sm text-primary hover:underline">Torna all'accesso</Link>
      </form>
    </AuthShell>
  );
}
